import React, { useEffect, useState } from "react";

import {toast} from "react-hot-toast"

function Settings() {


  const apiUrl = process.env.REACT_APP_API_URL;
  const seckey = process.env.REACT_APP_REV_KEY;


  const [actveManagetouggle , setActiveManageTougle]  =  useState(null)

    const [actveManageUser , setActiveManageUser]  =  useState(null)

const [subadminData, setSubadminData] = useState();

const [activeConfrom , setAtiveConform] = useState(false);


const [OpenAccess, setOpenAccess] = useState("");
const [accessValue, setAccessValue] = useState("");


  const [loading , setLoading] =  useState(false)

  const [data, setData] = useState({
    name:"",
    email:"",
    password:"",
    role:""
  })


const handleChangeUser = (e) => {
  const { name, value } = e.target; 
  setData({
    ...data,
    [name]: value, 
  });
};





const handleCreateUser = async (e) => {
  e.preventDefault();

  try {

    setLoading(true); 
    const response = await fetch(`${apiUrl}/auth/admin/reg-subadmin/r1`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "seckey":seckey
      },
      body: JSON.stringify(data),
    });

   

    const result = await response.json();
  
    if(response.ok){
      
      toast.success(result.message);
      setActiveManageTougle(null)
    }else{
      toast.error(result.message)
    }
 
    setData({
      name: "",
      email: "",
      password: "",
      role: "",
    });
  } catch (error) {
    console.error("Error creating user:", error);
    alert(`Failed to create user: ${error.message}`);
  } finally {
    setLoading(false); 
  }
};



  
//Get SubAdmin Details:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::


const getSubadmin = async()=>{
  setLoading(true)
  try {

    const  res = await fetch(`${apiUrl}/auth/admin/getsubadmin-details`,{
      method:"GET",
      headers:{
        "Content-Type":"application/json",
        "seckey":seckey
      }
    })

    const data = await res.json();
    if(res.ok){
    
      setSubadminData(data)
      
    } 
  } catch (error) {
    console.log(error)  
  }
  setLoading(false)
}

useEffect(()=>{
  getSubadmin();
},[])




const [activeConfirmId, setActiveConfirmId] = useState(null);

  const handleRemoveAccessClick = (id) => {
    setActiveConfirmId(id); 
  };

  const handleOk = async (id) => {
    try {
      const res = await fetch(`${apiUrl}/auth/admin/delete-subadmin/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "seckey": seckey,
        },
          withCredentials: true 
      });

      if (res.ok) {
        alert("Sub-admin deleted successfully");
        setActiveConfirmId(null); 
       
      } else {
        alert("Failed to delete sub-admin");
      }
    } catch (error) {
      console.log("Server Error:", error);
    }
  };

  const handleCancel = () => {
    setActiveConfirmId(null); 
  };



  return (
    <div>
      <div className="setting-bg">
        <div className="setting-main">

 <div className="setting-services-row">
    <div className="create-user-button-style"  onClick={() => setActiveManageTougle( actveManagetouggle ? false : true)}
>Create User </div> 

    <div className="setting-create-user-admin-details">



{


  actveManagetouggle === true ?

    <div className="setting-create-user-admin-details-container"> 

    <form onSubmit={handleCreateUser}>

      <div className="setting-create-user-admin-details-row">
        <div className="setting-create-user-admin-details-cols"><input placeholder="Enter user name"  value={data.name} onChange={handleChangeUser} name="name"  required /></div>
          <div className="setting-create-user-admin-details-cols"><input placeholder="Enter user Email"  value={data.email} onChange={handleChangeUser} name="email" required /></div>
      </div>
         <div className="setting-create-user-admin-details-row">
        <div className="setting-create-user-admin-details-cols"><input placeholder="Enter User Password" value={data.password}  onChange={handleChangeUser} name="password" required /></div>
          <div className="setting-create-user-admin-details-cols">
            <select name="role" onChange={handleChangeUser} value={data.role} >
              <option value=""  disabled >Select</option>
              <option value="adminuser">Sub Admin</option>

            </select>
          </div>
      </div>

      <div className="setting-create-user-submit"><button>Submit</button></div>

      </form>

      </div>
      :""

}





    </div>
 
 </div>



 <div className="setting-services-row"> 
   <div className="create-user-button-style"
    onClick={() => setActiveManageUser( actveManageUser ? false : true)}
   >Manage User </div>



{

  actveManageUser === true ?
  
  <div className="setting-sub-admin-details-container">

   <h4>Sub Admin Details</h4>

{
subadminData && subadminData.subadminList.map((e,index)=>{

   const utcDate = new Date(e.createdAt); 
 const istDate = utcDate.toLocaleDateString('en-GB', { timeZone: 'Asia/Kolkata' })

 return(
   <div className="setting-sub-admin-details-manage-row" key={index}>


     <div className="setting-sub-admin-details-manage-cols">
       <div> {e.name} </div>
       <div> {e.email}</div> 
     </div>

     <div className="setting-sub-admin-details-manage-cols">
       <div> {istDate}</div>
                <div
                  className="setting-sub-admin-removed-access"
                  onClick={() => handleRemoveAccessClick(e._id)}
                >
                  <i class="fa-solid fa-trash-arrow-up"></i> {e.accessAllow && e.accessAllow} Access
                </div>
  {activeConfirmId === e._id && (
                <div className="setting-sub-admin-removed-access-conform">
                  <button onClick={() => handleOk(e._id)}>Ok</button>
                  <button onClick={handleCancel}>Cancel</button>
                </div>
              )}

{/* Applying change Access Fatues::::::::::::::::::::::::::::::::: */}


<div 
  className="setting-edit-access-btn"
  onClick={() => {
    setOpenAccess(prev => prev === e._id ? "" : e._id);
    setAccessValue(e.accessAllow || "");  
  }}
>
  Edit 
</div>  

{OpenAccess === e._id && (
  <>
    <div>
      <select 
     value={accessValue}
    onChange={(e) => setAccessValue(e.target.value)}
      >
        <option value="AllAccess">All Access</option>
        <option value="GOC">GOC</option>
        <option value="Glazma">Glazma</option>
        <option value="FluffyTouch">FluffyTouch</option>
        <option value="BHUMU">Bhumu</option>
      </select>
    </div>

  <div 
  className="setting-save-access-btn setting-edit-access-btn"
  onClick={() => {

    fetch(`${apiUrl}/auth/set-access-allow/${e._id}`, {   
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        subadminId: e._id,      
        access: accessValue     
      })
    })
    .then(res => res.json())
    .then(data => {
      console.log("Updated:", data);

  
      setOpenAccess(""); 
      getSubadmin();


    })
    .catch(err => console.error("API Error:", err));

  }}
>
  Save
</div>

  </>
)}




     </div>


   

   </div>
 )
})
}





  </div>
  
   :""
} 

    </div>

        </div>
      </div>
    </div>
  );
}

export default Settings;
